<template>
    <div class="confirm-overtime">
        <!-- <myBreadCrumb :urls="JSON.stringify(breadcrumbs)" :icon="icon"></myBreadCrumb> -->
        <create-dialog v-model="dialog" @CloseDialog="dialog = {state: false, item: undefined}" :item="item" @fetch="fetchData"></create-dialog>
        <v-card class="rounded-xl" flat>
            <v-card-title class="text-h6 font-weight-bold">
                Phiếu làm thêm 
                <v-spacer></v-spacer> 
                
                <div class="d-flex align-center wrapper mx-1 my-1">
                    <v-btn @click="fetchData" outlined color="green lighten-3" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;">
                    <v-icon color="green darken-4">mdi-refresh</v-icon></v-btn>
                </div>
                <v-divider vertical class="mx-4"></v-divider>
                
                <export-dialog v-model="exportDialog"></export-dialog>
                
                <v-btn v-if="selectedItems.length > 0" @click="bulkAccept" :loading="isBulkApproving" dark color="orange darken-4" class="rounded-lg ml-4" large> 
                    <v-icon left>mdi-check-all</v-icon> Duyệt đã chọn ({{ selectedItems.length }})
                </v-btn>
                <v-btn @click="dialog.state=true" dark color="teal darken-4" class="rounded-lg ml-4" large> <v-icon left>mdi-plus</v-icon> Tạo phiếu </v-btn>
            </v-card-title>
            <v-sheet class="grey lighten-4 py-6">
                <div class="d-flex flex-wrap mx-n2 px-4">
                    <div class="d-flex align-center wrapper mx-2 my-2">
                        <month-picker width="7rem" v-model="month" label="Tháng" outlined dense></month-picker>
                    </div>
                    <v-text-field label="Ngày xét" outlined type="date" v-model="filters.execDate" hide-details dense
                    class="mx-2 my-2 flex-shrink-1" style="background-color: white;"
                    ></v-text-field>

                    <v-text-field label="Mã phiếu" dense v-model="filters.code" outlined hide-details persistent-placeholder
                        class="mx-2 my-2 flex-shrink-1" style="background-color: white;"></v-text-field>
 
                    <v-select label="Trạng thái" placeholder="Chọn" dense v-model="filters.status" outlined hide-details
                    :items='[{text:"Tất cả", value:-1},{text:"Chờ XN", value:0}, {text:"Đã XN", value:1}, {text:"Từ chối", value:2}]' 
                        class="mx-2 my-2 flex-shrink-1" style="max-width: 200px;background-color: white;"></v-select>
                        
                    <v-text-field label="Mã NS" placeholder="NS0000" dense v-model="filters.employeeCode" outlined hide-details persistent-placeholder
                    class="mx-2 my-2 flex-shrink-1" style="background-color: white;"></v-text-field>
                        
                    <v-text-field label="Tên NS" dense v-model="filters.employeeName" outlined hide-details persistent-placeholder placeholder="Tên Nhân Sự .. "
                        class="mx-2 my-2 flex-shrink-1" style="background-color: white;"></v-text-field>
                        
                    <!-- <v-text-field label="Tên phòng ban" dense v-model="filters.departmentName" outlined hide-details persistent-placeholder placeholder="TS00.."
                        class="mx-1 my-1 flex-grow-1 flex-shrink-0" style="min-width: 250px;"></v-text-field> -->
                        
                    <v-autocomplete label="Phòng ban" clearable outlined :items="departments.map(x=>{
                            return {
                                text: x.name,
                                value: x.code
                            }
                        })" v-model="filters.departmentCode" dense hide-details persistent-placeholder
                        class="mx-2 my-2 flex-shrink-1" style="min-width: 250px;background-color: white;"></v-autocomplete>
                        
                    <v-select label="Loại làm thêm" placeholder="Chọn" dense v-model="filters.overtimeTypeName" outlined hide-details persistent-placeholder
                            :items='overtimeTypes.map(x=>x.name)' clearable
                            class="mx-2 my-2 flex-shrink-1" style="min-width: 150px;max-width: 300px;background-color: white;"></v-select>
                        
                    <v-text-field label="Ngày áp dụng" type="date" clearable dense v-model="filters.date" outlined hide-details persistent-placeholder placeholder="Ngày áp dụng"
                        class="mx-2 my-2 flex-shrink-1" style="max-width: 200px;background-color: white;"></v-text-field>
                </div>
            </v-sheet>
            
            <!-- summarize sections -->
            <v-sheet class="px-6 py-3 d-flex align-center grey lighten-5" style="border-top: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
                <div class="subtitle-2 font-weight-bold mr-4 text-uppercase grey--text text--darken-2">Thống kê:</div>
                <v-chip color="blue lighten-4" text-color="blue darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-file-document-outline</v-icon>
                    Tổng phiếu: <b class="ml-1">{{ totalCount }}</b>
                </v-chip>
                <v-chip color="orange lighten-4" text-color="orange darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-clock-outline</v-icon>
                    Chờ duyệt: <b class="ml-1">{{ pendingCount }}</b>
                </v-chip>
                <v-chip color="green lighten-4" text-color="green darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-check-circle-outline</v-icon>
                    Đã duyệt: <b class="ml-1">{{ confirmedCount }}</b>
                </v-chip>
                <v-chip color="red lighten-4" text-color="red darken-4" class="font-weight-medium" small>
                    <v-icon left small>mdi-close-circle-outline</v-icon>
                     Từ chối: <b class="ml-1">{{ rejectedCount }}</b>
                </v-chip>
            </v-sheet>

            <v-data-table
                v-model="selectedItems"
                show-select
                item-key="code"
                height="calc(100vh - 300px)" fixed-header
                :headers="headers"
                :items="items"
                :loading="isLoading"
                loading-text="Đang tải dữ liệu..."
                :footer-props="{
                    itemsPerPage: '',
                    itemsPerPageOptions:[
                        50, 100, 200
                    ]
                }"
            >
                <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
                    <v-simple-checkbox v-if="item.status === 0" :ripple="false" color="primary" :value="isSelected" @input="select($event)"></v-simple-checkbox>
                </template>
                
                <template v-slot:[`item.employeeInfo`]="{item}">
                    <div class="subtitle-2 font-weight-bold" style="line-height: 1.2;">{{item.employeeName || (item.employee && item.employee.name)}}</div>
                    <div class="caption grey--text">{{item.employeeCode}}</div>
                </template>

                <template v-slot:[`item.processInfo`]="{item}">
                    <div style="line-height: 1.3;"><span class="grey--text caption">Gửi:</span> {{formatDate(item.sentDate)}}</div>
                    <div v-if="item.confirmByName" style="line-height: 1.3;"><span class="grey--text caption">Duyệt:</span> {{item.confirmByName}}</div>
                    <div v-if="item.confirmDate && item.status != 0" style="line-height: 1.3;"><span class="grey--text caption">Lúc:</span> {{formatDate(item.confirmDate)}}</div>
                </template>
                
                <template v-slot:[`item.actions`]="{item}" >
                    <!-- ********* Edit ****** -->
                    <v-btn x-small depressed rounded v-if="item.status == 0 && !isLoading" class="mx-1 my-1 green--text text--darken-3 font-weight-bold" color="green lighten-4" @click="accept(item)">
                        <v-icon left small>mdi-check-circle</v-icon> Duyệt
                    </v-btn>

                    <!-- ********* Xoa ****** -->
                    <v-btn x-small depressed rounded v-if="item.status == 0 && !isLoading" class="mx-1 my-1 red--text text--darken-3 font-weight-bold" color="red lighten-4" @click="decline(item)" >
                        <v-icon left small>mdi-close-circle</v-icon> Từ chối
                    </v-btn>

                    <!-- ********* Undo ****** -->
                    <v-btn x-small depressed rounded class="mx-1 my-1 blue-grey--text text--darken-3 font-weight-bold" v-if="item.status != 0" color="blue-grey lighten-4" @click="undo(item)" >
                        <v-icon left small>mdi-undo</v-icon> Hoàn tác
                    </v-btn>
                    
                    <v-btn x-small depressed rounded class="mx-1 my-1 red--text text--darken-2 font-weight-bold" color="grey lighten-4" @click="dialogDelete=true, targetItem=item" v-show="item.status == 0">
                        <v-icon left small>mdi-delete</v-icon> Xóa
                    </v-btn>
                </template>
                <template v-slot:[`item.departmentCodeNavigation.name`]="{ item }">
                    <v-chip class="ma-2 caption font-weight-bold" color="teal darken-4" label text-color="white" >
                    <v-icon left>
                        mdi-store
                    </v-icon>
                    {{item.departmentCodeNavigation.name}}
                    </v-chip>
                </template>
                <template v-slot:[`item.approvalStatus`]="{ item }">
                    <div class="mb-1 d-flex align-center"><span class="grey--text mr-2" style="width: 45px;">Cấp I:</span> <v-chip :color="$helper.formatStatus(item.subStatus).color" outlined small>{{$helper.formatStatus(item.subStatus).text}}</v-chip></div>
                    <div class="d-flex align-center"><span class="grey--text mr-2" style="width: 45px;">Cuối:</span> <v-chip :color="$helper.formatStatus(item.status).color" dark small>{{$helper.formatStatus(item.status).text}}</v-chip></div>
                </template>
                <template v-slot:[`item.overtimeInfo`]="{ item }">
                    <div style="line-height: 1.3;"><span class="grey--text caption">Ngày:</span> {{ formatDate(item.date) }}</div>
                    <div style="line-height: 1.3;"><span class="grey--text caption">Giờ:</span> {{ item.overtimeTimeStr }}</div>
                    <div style="line-height: 1.3;"><span class="grey--text caption">Tổng:</span> <b class="teal--text">{{ item.length }}h</b></div>
                </template>
            </v-data-table>
        </v-card>
        <!-- ************** DELETE CONFIRMATION *************** -->
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="headline">Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogDelete=false">Thoát</v-btn>
                <v-btn color="blue darken-1" text @click="cfmDeleteItem">OK</v-btn>
                <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import http from '@/components/services/http-common';
import myBreadCrumb from '@/components/BreadCrumb';
import DataFilter from '@/components/DataFilter';
// import CreateDialog from './Create.vue';
import * as moment from "moment/moment";
import Export from './Export.vue';
import Create from './Create';

export default {
    name: "Attendance",
    components: {
        myBreadCrumb,
        'data-filter': DataFilter,
        'export-dialog': Export,
        "create-dialog": Create,

    },
    props: ["breadcrumbs", "icon"],
    watch: {
        dialog(val) {
            if(!this.dialog)
                this.item=null;
        },
        tableParams: {
            handler (val) {
                this.fetchData();
            },
            deep: true,
        },
        filters: {
            handler (val) {
                this.tableParams.page=1;
                // this.fetchData();
            },
            deep: true,
        },
        month:{
            handler(val){
                this.filters.from=moment(val, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
                this.filters.to=moment(val, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
                this.fetchData();
            }
        }
    },
    computed: {
        params: function() {
            return {...this.tableParams, ...this.filters}
        },
        pendingCount() {
            return this.items.filter((item) => item.status === 0).length;
        },
        confirmedCount() {
            return this.items.filter((item) => item.status === 1).length;
        },
        rejectedCount() {
            return this.items.filter((item) => item.status === 2).length;
        },
        totalCount() {
            return this.items.length;
        }
    },
    data () {
        return {
            ROOT_URL: "overtimeRequests/",
            
            exportDialog: false,
            //filter
            // dialog:false,
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
                pageSize: 10000
            },
            month: moment().format("YYYY-MM"),
            filters:{
                execDate: moment().format("YYYY-MM-DD"),
                code: null,
                overtimeTypeName: null,
                employeeCode: null,
                employeeName: null,
                deparmentCode: null,
                departmentName: null,
                status: -1,
                from: moment().startOf("month").format("YYYY-MM-DD"),
                to: moment().endOf("month").format("YYYY-MM-DD"),
            },
            departmentSearch:null,
            departments: [],
            rowCount: 0,

            filter: {
                menu: false,
                search: "",
                searchAttr: "name",
                searchAttrs: undefined,
                FilterAttrs: [],
                FilterOn:["DepartmentTypeCode"],
                
                from: undefined,
                to: undefined,
                date: null,
                fromOns: [
                ],
                fromOn: "",
            },
            
            // VIEW DATA
            filterOpen: 1,

            //DATA TABLE
            totalItem: 0,
            items: [],
            selectedItems: [],
            isBulkApproving: false,
            search:"",
            options: {},
            isLoading: false,

            //DIALOG
            dialog: {
                state: false,
                item: undefined,
            },
            item: null,
            dialogDelete: false,
            targetItem: undefined,
            overtimeTypes: [],

            headers: [
                { text: 'Thao tác', value: 'actions', width: '8rem'},
                { text: 'Mã', align: 'start', value: 'code', width: '5rem',  
                    filter: value => {
                    if (!this.filters.code) return true
                    return value.toLowerCase().includes(this.filters.code.toLowerCase())
                    }
                },
                { text: 'Trạng thái duyệt', align: 'start', value: 'approvalStatus', width: '8rem'},
                { text: '', align: ' d-none', value: 'status',  
                    filter: value => {
                    if ( this.filters.status == -1) return true
                    return value === this.filters.status
                    }
                },
                { text: '', align: ' d-none', value: 'subStatus'},
                { text: 'Loại', align: 'start', value: 'overtimeTypeName', width: '10rem',  
                    filter: value => {
                    if ( !this.filters.overtimeTypeName) return true
                    return value === this.filters.overtimeTypeName
                    }
                },
                { text: 'Nhân viên', align: 'start', value: 'employeeInfo', width: '10rem'},
                { text: '', align: ' d-none', value: 'employeeCode', 
                    filter: value => {
                    if (!this.filters.employeeCode) return true
                    return value.toLowerCase().includes(this.filters.employeeCode.toLowerCase())
                    }
                },
                { text: '', align: ' d-none', value: 'employeeName',
                    filter: value => {
                    if (!this.filters.employeeName) return true
                    return value.toLowerCase().includes(this.filters.employeeName.toLowerCase())
                    }
                },
                { text: '', align: ' d-none', value: 'departmentCode', class: "d-none",
                    filter: value => {
                    if (!this.filters.departmentCode) return true
                    return value.toLowerCase().includes(this.filters.departmentCode.toLowerCase())
                    }
                },
                { text: 'Phòng ban', align: 'start', value: 'departmentName', width: '8rem',  
                    filter: value => {
                    if (!this.filters.departmentName) return true
                    return value.toLowerCase().includes(this.filters.departmentName.toLowerCase())
                    }
                },
                { text: 'Thời gian', align: 'start', value: 'overtimeInfo', width: '9rem'},
                { text: '', align: ' d-none', value: 'overtimeTimeStr'},
                { text: '', align: ' d-none', value: 'length'},
                { text: '', align: ' d-none', value: 'date',  
                    filter: value => {
                    if ( !this.filters.date) return true
                    let d1 = moment(value)
                    let d2 = moment(this.filters.date)
                    return d1.isSame(d2, 'day')
                    }
                },
                { text: 'Ghi chú', align: 'start', value: 'note', width: '10rem'},
                { text: 'Trạng thái xử lý', align: 'start', value: 'processInfo', width: '11rem'},
                { text: '', align: ' d-none', value: 'sentDate'},
                { text: '', align: ' d-none', value: 'confirmByName'},
                { text: '', align: ' d-none', value: 'confirmDate'},
                { text: '', align: ' d-none', value: 'remove'},
            ],
        }
    },
    methods: {
        formatDate(value) {
            return moment(value).format("DD/MM/YYYY");
        },
        formatStatus(value){
            switch(value){
                case 0:{
                    return "Chờ duyệt";
                }
                case 1:{
                    return "Chấp nhận";
                }
                case 2:{
                    return "Từ chối";
                }
            }
        },
        formatTime(value) {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
        },
        fetchDepartment() {
            return http.get("departments/fetch", {
                // params: {
                //     search: this.departmentSearch
                // }
            }).then(res => {
                this.departments = res.data;
            })
        },
        fetchData () {
            if(this.isLoading == false) {
                this.isLoading = true;
                return http.get(this.ROOT_URL+'admin/', {
                    params: this.params
                })
                .then(res => {
                    console.log(res.data, "fetch")
                    this.items = res.data.results;
                    this.rowCount = res.data.rowCount;
                })
                .catch(err => {

                })
                .finally(() => {
                    this.isLoading = false;
                })
            }
        },

        fetchOvertimeType () {
            return http.get('overtimetypes/fetch').then(r => {
                this.overtimeTypes = r.data.items
            } )
        },

        bulkAccept() {
            if (this.selectedItems.length === 0) return;
            this.isBulkApproving = true;
            const itemsToApprove = this.selectedItems.filter(item => item.status === 0);
            
            let promise = Promise.resolve();
            itemsToApprove.forEach(item => {
                promise = promise.then(() => {
                    return http.get(this.ROOT_URL + "accept/" + item.code).catch(error => {
                        console.error("Error accepting item: " + item.code, error);
                    });
                });
            });
            
            promise.finally(() => {
                this.isBulkApproving = false;
                this.selectedItems = [];
                this.fetchData();
            });
        },

        accept(item) {
            this.isLoading = true
            return http.get(this.ROOT_URL + "accept/" + item.code).then(res => {
                // let eventObj = {
                //     color: "success",
                //     message: "Cập nhật thành công",
                //     toast: true,
                // };
                // this.messageToast(eventObj);
                this.fetchData();
            }).catch(err => {
                console.log(err)
            }).finally(() => {
                this.isLoading = false
                this.fetchData()
            });
        },

        decline(item) {
            return http.get(this.ROOT_URL + "decline/" + item.code).then(res => {
                this.fetchData();
            }).catch(err => {
                console.log(err)
            });
        },

        undo(item) {
            http.get(this.ROOT_URL + "undo/" + item.code).then(res => {
                this.fetchData();
            }).catch(err => {
                console.log(err)
            });
        },

        edit(item){
            this.item = item;
            this.dialog = true;
        },
        
        remove(item){
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            console.log("remove");
            return http.delete(this.ROOT_URL+'admin/'+this.targetItem.code).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            })
        },
    },
    created () {
        this.fetchData();
        this.fetchDepartment()
        this.fetchOvertimeType()
    }
}
</script>
<style scoped>
    /* ::v-deep table > tbody > tr:nth-child(1)>td {
        padding-right: 1px !important;
        padding-left: 1px !important;
    } */
</style>